import styled from 'styled-components';
import { vars } from '@agendor/ui';

const Button = styled.button`
    background: transparent;
    border: 1px solid ${vars.dividerColor};
    border-radius: 6px;
    cursor: pointer;
    color: ${vars.foregroundColor};
    width: 36px;
    height: 36px;
    display: grid;
    place-items: center;
    flex-shrink: 0;

    &:hover {
        background-color: ${vars.backgroundColorBright};
    }

    &:active {
        transform: scale(0.95);
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export function RefreshButton({ onRefresh, disabled }: { onRefresh: () => void; disabled?: boolean }) {
    return (
        <Button onClick={onRefresh} aria-label="Atualizar" disabled={disabled}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
                style={{ width: 16, height: 16 }}
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />
            </svg>
        </Button>
    );
}
